import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  authNavigationText: {
    marginTop: "1rem",
    fontSize: "0.9rem",
    textAlign: "center",
    width: "100%",
    padding: "8px",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      lineJeight: "1.6rem",
    },
  },
}));
